// extracted by mini-css-extract-plugin
export default {"container":"PolicyTitle_container__7QhTR","title":"PolicyTitle_title__gofxo","back":"PolicyTitle_back__m0sAS"};